export const perfumeriaSlug = (p) => {
  const text = [p.brand, p.name].filter(Boolean).join(" ").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 78).replace(/-$/,"");
  const id = String(p.id || "").slice(-8);
  return (text || "fragrance") + "-" + id;
};
export const perfumeriaProductPath = (p) => "/perfumeria-pr/perfume/" + perfumeriaSlug(p);
export const perfumeriaProductName = (p) => {
  const brand = String(p.brand || "").trim();
  const name = String(p.name || "").trim();
  return brand && !name.toLowerCase().startsWith(brand.toLowerCase()) ? brand + " " + name : name;
};
